import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { FolderPlus, Loader2 } from 'lucide-react';

export const FolderDialog = ({ open, onOpenChange, title, initialName = '', location, onSubmit }) => {
  const [name, setName] = useState(initialName);
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      if (await onSubmit(name.trim())) onOpenChange(false);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[hsl(var(--card))] border-[hsl(var(--border))] max-w-sm" data-testid="folder-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FolderPlus size={18} className="text-cyan-400" /> {title}</DialogTitle>
          {location !== undefined && <DialogDescription>In: Library{location ? ` / ${location}` : ''}</DialogDescription>}
        </DialogHeader>
        <Input autoFocus value={name} maxLength={80} onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
          placeholder="e.g. Fira Worldwide" className="bg-[hsl(var(--surface))] border-[hsl(var(--border))]" data-testid="folder-name-input" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="folder-cancel-btn">Cancel</Button>
          <Button onClick={submit} disabled={saving || !name.trim()} className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white" data-testid="folder-save-btn">
            {saving && <Loader2 size={15} className="animate-spin mr-2" />} Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
